import { Navigate, useLocation } from "react-router-dom";

function RedirectToLogin() {
  const location = useLocation();

  sessionStorage.setItem(
    "redirectAfterLogin",
    location.pathname + location.search
  );

  return <Navigate to="/" replace />;
}

export default RedirectToLogin;